
/* Use case: Profile page */
ADILF.define('adilf/pages/profile/main',[
        'streamhub-sdk/jquery',
        'adilf/context',
        'adilf/util/utils',
        'adilf/apps/profile/app',
        'streamhub-author-content/author-content-client'
    ],
    function(jquery, Context, utils, ProfileStream, AuthorContentClient) {
    "use strict";

    return {
        init: function() {
            var self = this;
            
            self.debug.print("Intializing Profile app");
            jquery(function() {
                var UID = utils.livefyreSafeUIDEncode(window.m_user_userid);

                if(jquery('#advance-stream-user-comments').length > 0) {
                    var p = new ProfileStream({
                        userId: UID
                    });
                }

                var authorClient = new AuthorContentClient();
                authorClient.getAuthorStats({authorId: UID + '@' + Context.getNetworkId(), network: Context.getNetworkId()}, function (err, data) {
                    if (err || ! data) {
                        return;
                    }
                    jquery('#advance-count-user-comments').text(data.data.content.approvedCount);
                });

                if(jquery('.livefyre-commentcount').length > 0) {
                    require(['adilf/apps/commentcount/app'], function(CommentCount) {
                        var cc = new CommentCount();
                    });
                }

            });
        }
    };

});